<div class="title-bar no-container-margin">
  @for (breadCrumb of rootBreadCrumbs; track breadCrumb) {
    <span class="bread-crumb-root">{{breadCrumb | translate}}</span>
    <span class="bread-crumb-separator"> / </span>
  }
  <span class="bread-crumb-head">{{titleText | translate}}</span>
  <a href="https://help.avpark.ch" class="e-icons icon-help--filled help-icon" target="_blank"></a>
</div>
